import WelcomeMessage from "./WelcomeMessage";

export default WelcomeMessage;
